import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'
const {
  getPaginationCasts,
  getPaginationInject,
  toArrayOfInt,
  toArrayOfString,
} = useRouteParser()

const { t } = useI18n()

const module: RouteRecordRawArgumented = {
  path: 'teccom',
  name: 'teccom',
  redirect: () => ({ name: 'tecComIndex' }),
  children: [
    {
      path: 'orders/:step?',
      name: 'tecComIndex',
      component: () =>
        import(
          /* webpackChunkName: "teccom-index" */ 'pages/teccom/IndexPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.teccom.index'),
          icon: 'mdi-file-send-outline',
        },
        auth: {
          permission: 'teccom_submit_orders',
        },
        inject: {
          params: {
            step: 'select',
          },
          query: {
            sort: 'tof_datord',
            dir: 'desc',
          },
        },
        casts: {
          query: {
            ...getPaginationCasts(),
            supplier_id: toArrayOfInt,
          },
        },
      },
    },
    {
      path: 'dispatch-advices',
      name: 'tecComDispatchAdvices',
      component: () =>
        import(
          /* webpackChunkName: "teccom-dispatch-advices" */ 'pages/teccom/DispatchAdvicesIndex.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.teccom.dispatch_advices_index'),
          icon: 'mdi-file-document-outline',
        },
        auth: {
          permission: 'teccom_dispatch_advices_index',
        },
        inject: {
          query: {
            ...getPaginationInject(),
            // The API's own default: newest document first.
            sort: 'issue_date',
            dir: 'desc',
          },
        },
        casts: {
          query: {
            ...getPaginationCasts(),
            // Supplier *codes* — the API filters on the party number printed
            // on the document, not on the dashboard's supplier id.
            seller_party_number: toArrayOfString,
          },
        },
      },
    },
    {
      path: 'order-confirmations',
      name: 'tecComOrderConfirmations',
      component: () =>
        import(
          /* webpackChunkName: "teccom-order-confirmations" */ 'pages/teccom/OrderConfirmationsIndex.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.teccom.order_confirmations_index'),
          icon: 'mdi-file-check-outline',
        },
        auth: {
          permission: 'teccom_order_confirmations_index',
        },
        inject: {
          query: {
            ...getPaginationInject(),
            sort: 'issue_date',
            dir: 'desc',
          },
        },
        casts: {
          query: {
            ...getPaginationCasts(),
            seller_party_number: toArrayOfString,
          },
        },
      },
    },
  ],
}

export default module
